import { Icon24 } from 'cio-design-library/icons'
import { useControls, useTransformEffect } from 'react-zoom-pan-pinch'
import { useState } from 'react'
import { MAX_ZOOM_LEVEL, MIN_ZOOM_LEVEL, ZOOM_STEP } from '../../constants'
import { CurrentZoomLevel, ZoomControlButton, ZoomControlsContainer } from './styles'

export const ZoomControls = () => {
  const { zoomIn, zoomOut, instance } = useControls()

  const [zoomLevel, setZoomLevel] = useState(instance.transformState.scale)

  const zoomLevelText = `${Math.round(zoomLevel * 100)}%`

  useTransformEffect(({ state }) => {
    setZoomLevel(state.scale)
  })

  return (
    <ZoomControlsContainer>
      <ZoomControlButton onClick={() => zoomOut(ZOOM_STEP)} disabled={zoomLevel <= MIN_ZOOM_LEVEL}>
        <Icon24.Remove />
      </ZoomControlButton>
      <CurrentZoomLevel>{zoomLevelText}</CurrentZoomLevel>
      <ZoomControlButton onClick={() => zoomIn(ZOOM_STEP)} disabled={zoomLevel >= MAX_ZOOM_LEVEL}>
        <Icon24.Add />
      </ZoomControlButton>
    </ZoomControlsContainer>
  )
}
